// src/Sidebar.js
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import Cmdbeginner from "./component/Cmdbeginner";
import Character from "./component/Character";
import Lightcones from "./component/Lightcones";
import Items from "./component/Items";
import Scene from "./component/Scene";
import Spawn from "./component/Spawn";
import Relics from "./component/Relics";
import PerfectRelics from "./component/PerfectRelics";
import JsonUpload from "./component/JsonUpload";
import FreeCommand from "./component/FreeCommand";
import { customSelectStyles } from "./utils/styles"; // Import shared styles

function Sidebar({ changeComponent }) {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("cmdbeginner");

  const changeLanguage = (option) => {
    i18n.changeLanguage(option.value);
  };

  const languageOptions = [
    { value: "en", label: "English (EN)" },
    { value: "vi", label: "Tiếng Việt (VI)" },
  ];

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  const handleOptionClick = (key) => {
    setSelectedOption(key);

    switch (key) {
      case "cmdbeginner": changeComponent(<Cmdbeginner />, "cmdbeginner"); break;
      case "avatars": changeComponent(<Character />, "avatars"); break;
      case "lightcones": changeComponent(<Lightcones />, "lightcones"); break;
      case "items": changeComponent(<Items />, "items"); break;
      case "scene": changeComponent(<Scene />, "scene"); break;
      case "spawn": changeComponent(<Spawn />, "spawn"); break;
      case "relics": changeComponent(<Relics />, "relics"); break;
      case "perfectrelics": changeComponent(<PerfectRelics />, "perfectrelics"); break;
      case "jsonupload": changeComponent(<JsonUpload />, "jsonupload"); break;
      case "freecommand": changeComponent(<FreeCommand />, "freecommand"); break;
      default: changeComponent(<Cmdbeginner />, "cmdbeginner"); break;
    }

    // Close sidebar on mobile selection
    if (window.innerWidth < 1024) {
      closeSidebar();
    }
  };

  const menuItems = [
    "cmdbeginner",
    "lightcones",
    "avatars",
    "items",
    "scene",
    "spawn",
    "relics",
    "perfectrelics",
    "jsonupload",
    "freecommand"
  ];

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-space-blue-800 text-stardust-gold border border-stardust-gold/30 shadow-lg hover:bg-space-blue-700 transition"
        onClick={toggleSidebar}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Sidebar Container */}
      <div className={`fixed inset-y-0 left-0 transform ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 lg:static lg:inset-auto z-40 transition-transform duration-300 ease-in-out`}>
        <div className="h-full w-72 p-4 flex flex-col glass-panel rounded-r-2xl lg:rounded-2xl lg:m-4 lg:h-[calc(100vh-2rem)] overflow-hidden">

          {/* Logo / Header */}
          <div className="mb-8 p-2 text-center border-b border-white/10 pb-4">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-stardust-gold-light to-stardust-gold bg-clip-text text-transparent">
              {t("logo")}
            </h3>
          </div>

          {/* Navigation Items */}
          <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar space-y-1">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 pl-2">{t("feature")}</p>
            {menuItems.map((key) => (
              <div
                key={key}
                onClick={() => handleOptionClick(key)}
                className={`
                  cursor-pointer px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200
                  ${selectedOption === key
                    ? "bg-gradient-to-r from-space-blue-500/50 to-transparent border-l-4 border-stardust-gold text-stardust-gold-light shadow-md"
                    : "text-gray-400 hover:text-white hover:bg-white/5 border-l-4 border-transparent"}
                `}
              >
                {t(key)}
              </div>
            ))}
          </div>

          {/* Footer / Language Selector */}
          <div className="mt-4 pt-4 border-t border-white/10">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">{t("languages")}</p>
            <Select
              styles={customSelectStyles}
              options={languageOptions}
              onChange={changeLanguage}
              placeholder={t("selectLanguage")}
              menuPlacement="top"
              menuPosition="fixed"
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 lg:hidden"
          onClick={closeSidebar}
        />
      )}
    </>
  );
}

export default Sidebar;
